const AdminDashboard = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>Admin Dashboard</h1>
      <p>Welcome. Features coming soon.</p>
    </div>
  );
};

export default AdminDashboard;
